/**
 * Javascript to replace the base URL with the shortcode [site_url] when editing a link
 */
jQuery( document ).ready(
	function ($) {
		$( 'body' ).on(
			'DOMSubtreeModified',
			'#search-panel',
			function () {
				$( 'li .item-permalink' ).each(
					function () {
						var link_item = $( this );
						var value     = link_item.val();
						var url       = value.replace( relative_links.settings.base_url, '[site_url]' );
						link_item.val( url );
					}
				);
			}
		);
	}
);
